import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import InformDialog from '../InformDialog';
import { ObterDadosCPF, ObterDadosCNPJ } from 'services/actions/ConectaGovRepem';
import { api } from '../../../services/api';
import { signoutRedirect } from 'services/actions/Autenticacao/AuthService';
import { useDispatch } from 'react-redux';
import { showAlert } from 'store/actions/alertsActions';
import { loadingStart,loadingEnd } from 'store/actions/loadingActions';


function InformloadRequerimentoDialog() {
  const dispatch = useDispatch();
  const [dialog, setDialog] = useState(<></>);
  const user = useSelector((store) => {
    return store.userState.user;
  });

  const represented = useSelector((store) => {
    return store.userState.represented;
  });

  const atualizarDadosCadastrais = useSelector((store) => {
    return store.dadoCadastralState.atualizarDadosCadastrais;
  });

  function onClose() {
    signoutRedirect();
  }

  function onCloseSDC() {
    window.location.replace(
      atualizarDadosCadastrais.url + '?returnUrl=requerimento'
    );
  }

  const hasRepresented = () => !!represented?.representedCpfCnpj && represented?.representedCpfCnpj.length >= 14;
  const documentoAtual =
    represented?.representedCpfCnpj?.length >= 14
      ? represented.representedCpfCnpj
      : user?.userCpf;

  // Valida se um CNPJ pertence a órgão público
  function validaNaturezaJuridica(dadosCnpj) {
    if (
      !dadosCnpj ||
      !dadosCnpj.naturezaJuridica ||
      dadosCnpj.naturezaJuridica.codigo == null
    ) {
      return false;
    }
    // códigos < 2000 = órgão público → inválido
    return dadosCnpj.naturezaJuridica.codigo < 2000;
  }
  // Valida se está usando filial
  function validaUsandoFilial(dadosCnpj) {
    // se não houver dados suficientes → validação positiva
    if (
      !dadosCnpj ||
      dadosCnpj.tipoEstabelecimento == null
    ) {
      return false;
    }
    // "1" = matriz | diferente de "1" = filial
    return !(dadosCnpj.tipoEstabelecimento === "1");
  }
  // Valida se é Estrangeiro
  function validaEstrangeiro(dadosCpf) {
    if (
      !dadosCpf ||
      dadosCpf.estrangeiro == null
    ) {
      return false;
    }
    const isEstrangeiro = dadosCpf?.estrangeiro?.toUpperCase() == "S";
    return isEstrangeiro;
  }

  function validaCNPJ(dadosCnpj) {
    if (!dadosCnpj.cpf && dadosCnpj.msgRetornoAPI) {
        
      dispatch(showAlert(dadosCnpj.msgRetornoAPI, 'error'));
      
      //Aguarda e depois desloga
      setTimeout(() => {
        signoutRedirect();
      }, 7000);
    }else if (validaUsandoFilial(dadosCnpj)) {
      setDialog(
        <InformDialog
          onClose={onClose}
          countdown={20000}
          informacao={<div>
            <p>
              O REPEM detectou que o CNPJ declarado pertence à uma
              filial, contrariando ao disposto no art. 2º da Portaria
              DNPM nº 15, de 07 de janeiro de 2008.
            </p>
          </div>} />
      );
    } else if (validaNaturezaJuridica(dadosCnpj)) {
      setDialog(
        <InformDialog
          onClose={onClose}
          countdown={20000}
          informacao={<div>
            <p>CNPJ exclusivo para Registro de Extração</p>
          </div>} />
      );
    }
  }

function validaCPF(dadoscpf) {
  if (
    !dadoscpf.cpf &&
    dadoscpf.msgRetornoAPI
  ) {
      dispatch(showAlert(dadoscpf.msgRetornoAPI, 'error'));
      
      //Aguarda e depois desloga
      setTimeout(() => {
        signoutRedirect();
      }, 7000);
  }else if (validaEstrangeiro(dadoscpf)) {
      setDialog(
        <InformDialog
          onClose={onClose}
          countdown={20000}
          informacao={<div>
            <p>
              A autorização de pesquisa será outorgada a brasileiro,
              sociedade empresária constituída sob as leis brasileiras
              e com sede e administração no País
            </p>
          </div>} />
      );
    }
  }

  useEffect(() => {
    if (atualizarDadosCadastrais?.necessarioAtualizar && user?.userType === '2') {
      setDialog(
        <InformDialog
          titulo="Informações para primeiro acesso ao sistema REPEM"
          informacao="Para o primeiro acesso ao sistema REPEM de Pessoa Física ou Pessoa Jurídica é necessária a atualização dos dados cadastrais do requerente no Sistema de Dados Cadastrais (SDC) da ANM. O requerente será redirecionado ao SDC."
          onClose={onCloseSDC}
          countdown={20000}
        />
      );
    }
  }, [atualizarDadosCadastrais?.necessarioAtualizar, user?.userType]);


  useEffect(() => {
    if (!documentoAtual) return;

    const carregarDados = async () => {
      dispatch(loadingStart());

      try {
        if (documentoAtual.length >= 14) {
          const dados = await ObterDadosCNPJ(documentoAtual);
          validaCNPJ(dados);
        } else {
          const dados = await ObterDadosCPF(documentoAtual);
          validaCPF(dados);
        }
      } catch (error) {
        console.error("Erro ao consultar dados usuário:", error);
      } finally {
        dispatch(loadingEnd());
      }
    };

    carregarDados();
  }, [documentoAtual, represented?.representedId]);

  return <>{dialog}</>;
}

export default InformloadRequerimentoDialog;
